import {
  pageInfo,
  exportData
} from './../api';
import { regionSelect, taskPkgAreaCitySelect, taskPkgTypeSelect } from '../../../../api'

const clockInData = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    regionObj: null,
    areaCityObj: null,
    taskPkgTypeObj: null,
    exportObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    REGION_SELECT(state, data) {
      state.regionObj = data.obj;
    },
    AREA_CITY_SELECT(state, data) {
      state.areaCityObj = data.obj;
    },
    TASK_PKG_TYPE_SELECT(state, data) {
      state.taskPkgTypeObj = data.obj;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async regionSelect({ commit }, obj) {
      let resp = await regionSelect(obj);
      commit('REGION_SELECT', resp);
    },
    async taskPkgAreaCitySelect({ commit }, obj) {
      let resp = await taskPkgAreaCitySelect(obj);
      commit('AREA_CITY_SELECT', resp);
    },
    async taskPkgTypeSelect({ commit }, obj) {
      let resp = await taskPkgTypeSelect(obj);
      commit('TASK_PKG_TYPE_SELECT', resp);
    },
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default clockInData



// WEBPACK FOOTER //
// ./src/page/dataManagement/clockInData/store/clockInData.store.js